import { ProductGroup } from 'types/newproductwall';
import { Tooltip } from '@nike/eds';

type CardContentProps = {
  data: ProductGroup;
};

export default function CardContent(props: CardContentProps) {
  const { data } = props;
  const imageUrl = data.properties?.portraitURL;
  const destinationUrl = data.properties?.actions?.[0]?.destination?.url;

  if (!imageUrl) {
    return null;
  }

  const cardContent = (
    <div
      className='tw-rounded tw-bg-white tw-w-60 tw-relative'
      style={{ boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)' }}
    >
      <img
        src={imageUrl}
        className='tw-rounded tw-object-cover tw-w-full'
        alt='card content'
      />
    </div>
  );

  if (destinationUrl) {
    return (
      <Tooltip
        bodySlot={
          <div className='tw-text-gray-100 tw-text-xs tw-max-w-xs tw-break-all'>
            {destinationUrl}
          </div>
        }
        isDark
        placement='top'
      >
        {cardContent}
      </Tooltip>
    );
  }

  return cardContent;
}
